module.exports = __webpack_public_path__ + "img/2.4c1549a6.png";